import { VEHICLE_CATEGORIES } from "@/data/vehicle";
import { Document, Vehicle } from "@/lib/services/vehicles";
import { BrandColors } from "@/constants/theme";

export function formatVehicleLabel(value?: string): string {
  if (!value) {
    return "";
  }

  return value
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function getVehicleTitle(vehicle: Vehicle): string {
  const parts = [
    vehicle.year ? String(vehicle.year) : null,
    formatVehicleLabel(vehicle.make),
    formatVehicleLabel(vehicle.model),
  ].filter(Boolean);

  return parts.join(" ") || vehicle.registration_number;
}

export function getVehiclePhotoUrl(vehicle: Vehicle): string | null {
  const photo = vehicle.documents?.find(
    (document: Document) => document.type === "vehicle_photo",
  );

  return photo?.url ?? null;
}

export function getVehicleTypeShortLabel(vehicleType: string): string {
  const category = VEHICLE_CATEGORIES.find(
    (item) => item.value === vehicleType,
  );

  return category?.label ?? formatVehicleLabel(vehicleType);
}

export function formatMileage(mileage?: string): string | null {
  if (!mileage) {
    return null;
  }

  const numeric = mileage.replace(/,/g, "");
  if (!/^\d+$/.test(numeric)) {
    return mileage;
  }

  return `${Number(numeric).toLocaleString()} miles`;
}

export function getAvailabilityBadge(isAvailable: boolean) {
  return isAvailable
    ? {
        label: "AVAILABLE",
        backgroundColor: BrandColors.primaryLight,
        color: BrandColors.primary,
      }
    : {
        label: "UNAVAILABLE",
        backgroundColor: "#FEF3C7",
        color: "#D97706",
      };
}
